import React from 'react';
import PropTypes from 'prop-types';
import { getResourceTo } from 'react/utils/utils';
import { FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { CheckboxField } from 'react/components/fields';

const CreateUsersCheckboxHint = (createUsers) => (
  <>
    <div className={`${createUsers ? 'flaggedParagraph' : ''}`}>
      {getResourceTo('samlConfiguration.createUsers.firstParagraph')}
    </div>
    <div className={`${!createUsers ? 'flaggedParagraph' : ''}`}>
      {getResourceTo('samlConfiguration.createUsers.secondParagraph')}
    </div>
  </>
);

const UpdateUsersCheckboxHint = (updateUsers) => (
  <>
    <div className={`${updateUsers ? 'flaggedParagraph' : ''}`}>
      {getResourceTo('samlConfiguration.updateUsers.firstParagraph')}
    </div>
    <div className={`${!updateUsers ? 'flaggedParagraph' : ''}`}>
      {getResourceTo('samlConfiguration.updateUsers.secondParagraph')}
    </div>
  </>
);

function UsersCreationAndUpdate({ idpName, createUsers, updateUsers }) {
  return (
    <FormSection
      title={getResourceTo(
        'samlConfiguration.usersCreationAndUpdate.title',
        idpName
      )}
      subtitle="samlConfiguration.usersCreationAndUpdate.subtitle"
      className="userCreateSection"
    >
      <FormSectionColumn>
        <CheckboxField
          name="idp.createUsers"
          label="samlConfiguration.createUsers"
          customHint={<CreateUsersCheckboxHint createUsers={createUsers} />}
        />
        <CheckboxField
          name="idp.updateUsers"
          label="samlConfiguration.updateUsers"
          customHint={<UpdateUsersCheckboxHint updateUsers={updateUsers} />}
        />
      </FormSectionColumn>
    </FormSection>
  );
}

UsersCreationAndUpdate.propTypes = {
  idpName: PropTypes.string,
  createUsers: PropTypes.func.isRequired,
  updateUsers: PropTypes.func.isRequired
};

UsersCreationAndUpdate.defaultProps = {
  idpName: ''
};

export default UsersCreationAndUpdate;
